import { Box, Container, GlobalStyles, Grid, Paper, Typography } from "@mui/material"
import background from "../images/backgroundImage.png"
import { useContext, useEffect } from "react";
import { AppContext } from "../context";
import { useLocation, useParams } from "react-router-dom";
import React from "react";
import { Form } from "../components/DataForm";
import { useWindowDimensions } from "../hooks/useWindowDimensions";
import { ShortIdForm } from "../components/shortIdForm";


export const ConfirmationPage = () => {
  const { logo, backgroundImage, lead, theme, codeValidation } =  useContext<any>(AppContext);
  const { width } = useWindowDimensions();
  const background = theme ? theme.palette.background.default : '#fff'


    return (
      <>
      {/* {plan &&( */}
      <Box sx={{ 
        maxHeight: '100vh',
        width: '80vw',
        maxWidth: '1500px',
        margin: 'auto',
        paddingTop: '10px' }}>

          <GlobalStyles
        styles={{
          body: {
          backgroundColor: `${background}`,
          padding: '5px',
          maxHeight: '100vh'
          }
      }}
      />
      <Paper sx={{
        my: 'auto',
        maxHeight: 650,
        backgroundColor: "background.default",
        boxShadow: 0
        }}
      >
      <Grid container >
          <Grid
           item
           xl={8} 
           md={8} 
           sm={12}
           sx={{
            display: 'flex',
            flexDirection: 'column',
            // justifyContent: 'space-evenly',
            mb: width > 400 ? 0 : 2,
           }}>
        <Box sx={{
          //  pl: width > 400 ? 8 : 3,
           display: 'flex',
           flexDirection: 'column',
           justifyContent: 'space-between',
           mb: width > 400 ? 1 : 2,
           mt: width > 400 ? 3 : 2,
          }}>
        <Box>
            <img
             src={logo} 
             alt="" 
            style={{width: '110px'}} />
        </Box>
        <Box>
        <Typography sx={{
            color: 'primary.main', 
            fontSize: '2rem', 
            // fontWeight: 'bold',
            fontStyle: 'italic',
            mt: 3
          }}
            >
            Confirme sua compra!
          </Typography>
          
        </Box>
        </Box>
        {!codeValidation ? <>
          <Box sx={{marginY: '10%'}}>
         
          <Typography
           sx={{color: 'secondary.main', fontSize: '1.6rem'}}>
            Enviamos email de confirmação para:
          </Typography>
          <Typography
           sx={{color: 'primary.main', fontSize: '1.6rem', mb: 2}}>
          <strong>{lead.email}</strong>
          </Typography>
        </Box>
        <Box>
          <Typography
           sx={{color: 'secondary.main', fontSize: '1.6rem',}}>
          </Typography>
          <Typography
           sx={{color: 'secondary.main', fontSize: '1.6rem'}}>
           Em caso de dúvida, entre em contato conosco:
          </Typography>
          <Typography
           sx={{color: 'primary.main', fontSize: '1.6rem', mb: 2}}>
          <strong>atendimento@briasaude.com</strong>
          </Typography>
          </Box>
          </>
          :
          <>
          <Box sx={{marginY: '10%'}}>
          <Typography
           sx={{color: 'secondary.main', fontSize: '1.6rem',}}>
          </Typography>
          <Typography
           sx={{color: 'secondary.main', fontSize: '1.6rem'}}>
            Enviamos seu código de confirmação para:
          </Typography>
          <Typography
           sx={{color: 'primary.main', fontSize: '1.6rem', mb: 2}}>
          <strong>{lead.email}</strong>
          </Typography>
        </Box>
        <Box>
          <ShortIdForm />
          </Box>
        </>}
        
        
          </Grid>
          {width > 1000 && (
          <Grid item  >
            <Box sx={{
                maxHeight: "100%", 
                width: "100%",
                display: 'flex',
                justifyContent: 'flex-end' }}>
                <img src={backgroundImage} width="350px" alt='' />
            </Box>
          </Grid>
          )}
      </Grid>
      </Paper>
      </Box>
      {/* )} */}
      </>
    )
}